<template>
  <div class="news">
    <div class="news-form">
      <FirstStep
        :id="id"
        :type="type"
        @changeActive="active = 2"
        :spider="siteForm.spider"
        v-if="active == 1"
        @back="back"
      />
      <SecondStep :spiderParse="siteForm.spiderParse" v-if="active == 2" />
    </div>
    <div class="news-btns">
      <a-button @click="back()" v-if="editId && active > 1">返回</a-button>
      <a-button size="large" v-if="active > 1" @click="active--">上一步</a-button>
      <!-- <a-button size="large" v-if="active == 2" @click="visible = true"> 测试</a-button> -->
      <a-button
        v-if="active == 2"
        size="large"
        type="primary"
        @click="handleSubmit"
        :loading="submitLoading"
      >
        {{ editId ? '修改' : '创建' }}
      </a-button>
    </div>
    <a-modal
      width="1000px"
      v-model="visible"
      :footer="null"
      title="测试结果"
      @cancel="handleCancel"
    >
      <a-input-search
        v-model="url"
        placeholder="请输入需要测试的URL"
        enter-button="执行"
        @search="handleTest"
        :loading="parseLoading"
      />
      <h1 class="center test-title">{{ parseHtml.title }}</h1>
      <p v-if="parseHtml.author || parseHtml.publish_time" class="center author">
        <span>作者：</span>{{ parseHtml.publisher }}
        <span style="margin-left: 20px">发布时间：</span>{{ parseHtml.publish_time }}
      </p>
      <div v-if="parseHtml.abstract">
        <p class="test-key">摘要：</p>
      </div>
      <p v-if="parseHtml.keyword"><span class="test-key">关键字：</span></p>
      <template v-for="item in parseHtml.content_list">
        <p class="center" v-if="item['img']">
          <img style="max-width: 100%" :src="item.img" :alt="item.alt" />
          <span>{{ item.alt }}</span>
        </p>
        <p v-else class="test-content" v-text="item['p']"></p>
      </template>

      <div v-if="parseHtml.files_info">
        <p class="test-key">文件列表：</p>
        <p class="test-content file-url" v-for="file in parseHtml.files_info">
          {{ file.img }}
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  addSpiderItemApi,
  addSpiderApiItem,
  getSpiderByIdApi,
  getSpiderDocByIdApi,
  updateSpiderItemApi,
  updateSpiderApiItemApi,
  updateSpiderDocItemApi,
  testSpiderApi,
  addSpiderDocumentItem
} from '@/api/Site/Create'
import FirstStep from './FirstStep'
import SecondStep from './SecondStep'
import { onHttpResponse, onHttpResponseSilent } from '@/utils/request'
import { queryTagListApi } from '@/api/Site/Create'

// 头条 和 新闻
export default {
  data() {
    return {
      editId: '',
      active: 1,
      siteForm: {
        spider: {
          spiderId: '',
          spiderClassId: '',
          spiderName: '',
          spiderUrl: [],
          country: 'cn',
          spiderLevel: 2,
          deployType: 0,
          codeType: 'page',
          lang: 'zh',
          spiderExecTimeType: 1,
          spiderExecTimeCycle: 10,
          whiteConfig: {
            hosts: [],
            paths: []
          },
          blackConfig: {
            hosts: [],
            paths: []
          },
          spiderTags: [],
          timeOut: 10000,
          retryNum: 3,
          synCycle: 0,
          synNum: 32,
          ipConfig: {
            enabled: 0
            // url: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
          },
          ipConfigNum: 0,
          ipConfigCountry: ''
        },
        spiderParse: {
          spiderParseType: 4,
          spiderParseConfig: [
            {
              urls: [''],
              parseId: 'sputniknews_document_parse_id',
              config: [
                { name: 'title', rule: '' },
                { name: 'content', rule: '' },
                { name: 'publisher', rule: '' },
                { name: 'publish_time', rule: '' },
                { name: 'keywords', rule: '' },
                { name: 'file', rule: '' },
                { name: 'origin', rule: '' },
                { name: 'description', rule: '' }
              ]
            }
          ]
        }
      },
      url: '',
      visible: false,
      parseHtml: {},
      parseLoading: false,

      submitLoading: false, // 创建和修改时的loading

      labels: []
    }
  },
  props: ['onSubmited', 'id', 'type'],
  async created() {
    // 先这样
    await this.getLabels()
    // const { spiderClassId } = this.$route.query

    // if (this.id) {
    //   this.siteForm.spider.spiderClassId = Number(this.id)
    // }

    // let { spiderId, type } = this.$route.query

    if (this.id) {
      if (this.type === 'news') {
        this.getSpiderById(this.id)
      } else {
        this.getSpiderApiById(this.id)
      }
      this.editId = this.id
    }
  },
  methods: {
    back() {
      // sessionStorage.types = 'others'
      // this.$router.back(-1)
      this.$emit('back')
    },
    getLabels() {
      return queryTagListApi({
   
      })
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.labels = data
        })
    },

    handleCancel() {
      this.visible = false
      this.parseHtml = {
        files: [],
        content: ''
      }
    },
    //新闻
    getPostData(runNow) {
      return {
        spider: {
          ...this.siteForm.spider,
          tags: this.siteForm.spider.spiderTags.map((tag) => tag.spiderTagId),
          mqConfig: window.spider.news.mqConfig,
          execType: runNow ? 1 : 0,
          spiderClassType: 'news',
          spiderUrl: this.siteForm.spider.spiderUrl || [],
          blackConfig: {
            host: this.siteForm.spider.blackConfig.hosts || [],
            path: this.siteForm.spider.blackConfig.paths || []
          },
          whiteConfig: {
            host: this.siteForm.spider.whiteConfig.hosts || [],
            path: this.siteForm.spider.whiteConfig.paths || []
          },
          country: this.siteForm.spider.country,
          lang: this.siteForm.spider.lang
        },
        spiderParse: {
          ...this.siteForm.spiderParse,
          spiderParseConfig: this.siteForm.spiderParse.spiderParseConfig.map((item) => {
            return {
              ...item,
              config: item.config
            }
          })
        }
      }
    },
    // 云采集
    getPostDataApi(runNow) {
      let data = {
        ...this.siteForm.spider,
        tags: this.siteForm.spider.spiderTags.map((tag) => tag.spiderTagId),
        spiderClassType: 'api',
        // country: this.siteForm.spider.country,
        // lang: this.siteForm.spider.lang,
        execType: runNow ? 1 : 0,
        spiderUrl: this.siteForm.spider.spiderUrl,
        mqConfig: window.spider.default.mqConfig,
        spiderParse: this.siteForm.spiderParse
      }
      return data
    },

    // 文档
    getPostDataDoc(runNow) {
      let data = {
        ...this.siteForm.spider,
        tags: this.siteForm.spider.spiderTags.map((tag) => tag.spiderTagId),
        spiderClassType: 'api',
        // country: this.siteForm.spider.country,
        // lang: this.siteForm.spider.lang,
        execType: runNow ? 1 : 0,
        spiderUrl: this.siteForm.spider.spiderUrl,
        mqConfig: window.spider.default.mqConfig,
        country: this.siteForm.spider.country,
        spiderParse: this.siteForm.spiderParse
      }
      return data
    },

    async addSpiderItem() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: '调度任务确认',
          content: '是否立刻开启调度任务?',
          autoFocusButton: 'ok',
          cancelText: '暂不开启',
          okText: '立即开启',
          onOk: async () => {
            await this._addSpiderItem(true)
            resolve()
          },
          onCancel: async () => {
            await this._addSpiderItem(false)
            resolve()
          }
        })
      })
    },

    async _addSpiderItem(runNow) {
      this.submitLoading = true

      // const { type } = this.$route.query
      switch (this.type) {
        case 'news':
          let postData = this.getPostData(runNow)
          addSpiderItemApi(postData)
            .then(onHttpResponse)
            .then(() => {
              this.$router.push({ name: 'site_manage' })
            })
            .catch(() => {})
          break
        case 'api':
          let postDataApi = this.getPostDataApi(runNow)
          addSpiderApiItem(postDataApi)
            .then(onHttpResponse)
            .then(() => {
              this.$router.push({ name: 'site_manage' })
            })
            .catch(() => {})
        case 'document':
          let postDataDocument = this.getPostDataDoc(runNow)
          addSpiderDocumentItem(postDataDocument)
            .then(onHttpResponse)
            .then(() => {
              this.$router.push({ name: 'site_manage' })
            })
            .catch(() => {})
          break
      }
    },

    async updateSpiderItem() {
      // const { type } = this.$route.query
      switch (this.type) {
        case 'news':
          let postData = this.getPostData()
          delete postData.execType
          let res = await updateSpiderItemApi(postData)
          let { code, msg } = res
          if (code === 200) {
            this.$message.success(msg)
            if (this.onSubmited) {
              this.onSubmited(res)
            } else {
              // this.$router.push({ name: 'site_manage' })
              this.back
            }
          } else {
            this.$message.error(msg)
          }
          break
        case 'api':
          let postDataApi = this.getPostDataApi()
          delete postDataApi.execType
          updateSpiderApiItemApi(postDataApi)
            .then(onHttpResponseSilent)
            .then(() => {
              if (this.onSubmited) {
                this.onSubmited(res)
              } else {
                this.$router.push({ name: 'site_manage' })
              }
            })
        case 'document':
          let postDataDoc = this.getPostDataDoc()
          // delete postDataDoc.execType
          updateSpiderDocItemApi(postDataDoc)
            .then(onHttpResponseSilent)
            .then(() => {
              if (this.onSubmited) {
                this.onSubmited(res)
              } else {
                this.$router.push({ name: 'site_manage' })
              }
            })
      }
    },

    async getSpiderById() {
      let res = await getSpiderByIdApi({ spiderId: this.id, type: this.type })
      let { code, msg, extra } = res
      if (code === 200) {
        Object.assign(this.siteForm.spider, { spiderUrl: extra.data.spiderUrl }, extra.data)
        if (!extra.data.blackConfig.hosts) this.$set(this.siteForm.spider.blackConfig, 'hosts', [])
        if (!extra.data.blackConfig.paths) this.$set(this.siteForm.spider.blackConfig, 'paths', [])
        if (!extra.data.whiteConfig.hosts) this.$set(this.siteForm.spider.whiteConfig, 'hosts', [])
        if (!extra.data.whiteConfig.paths) this.$set(this.siteForm.spider.whiteConfig, 'paths', [])

        Object.assign(this.siteForm.spiderParse, {
          spiderParseType: extra.data.spiderParse.spiderParseType,
          spiderParseConfig: extra.data.spiderParse.spiderParseConfig
        })
      } else {
        this.$message.error(msg)
      }
    },

    async getSpiderApiById() {
      await getSpiderDocByIdApi({ spiderId: this.id })
        .then(onHttpResponseSilent)
        .then((res) => {
          let { code, msg, extra } = res
          if (code === 200) {
            Object.assign(this.siteForm.spider, { spiderUrl: extra.data.spiderUrl }, extra.data)
            if (!extra.data.blackConfig.hosts)
              this.$set(this.siteForm.spider.blackConfig, 'hosts', [])
            if (!extra.data.blackConfig.paths)
              this.$set(this.siteForm.spider.blackConfig, 'paths', [])
            if (!extra.data.whiteConfig.hosts)
              this.$set(this.siteForm.spider.whiteConfig, 'hosts', [])
            if (!extra.data.whiteConfig.paths)
              this.$set(this.siteForm.spider.whiteConfig, 'paths', [])
            Object.assign(this.siteForm.spiderParse, {
              spiderParseType: extra.data.spiderParse.spiderParseType,
              spiderParseConfig: extra.data.spiderParse.spiderParseConfig
            })
          }
        })
    },

    _fullSpiderParseConfig(config) {
      let _config = [...config]
      let configNames = config.map((c) => c.name)
      let needNames = [
        'title',
        'content',
        'publisher',
        'publish_time',
        'keywords',
        'file',
        'origin',
        'description'
      ]
      needNames.forEach((n) => {
        if (!configNames.includes(n)) {
          _config.push({ name: n, rule: '' })
        }
      })
      return _config
    },

    async handleSubmit() {
      if (this.editId) {
        this.submitLoading = true
        await this.updateSpiderItem()
      } else {
        await this.addSpiderItem()
      }
      this.submitLoading = false
    },

    async handleTest() {
      if (this.url.trim() == '') {
        this.$message.error('url不能为空!')
        return
      }
      this.parseLoading = true
      testSpiderApi({ ...this.getPostData(this.siteForm) }, { url: this.url })
        .then(onHttpResponse)
        .then((res) => {
          let { extra } = res
          this.parseHtml = extra.parseHtml
          this.visible = true
        })
        .finally(() => {
          this.parseLoading = false
        })
    }
  },
  components: {
    FirstStep,
    SecondStep
  }
}
</script>

<style lang="less" scoped>
.news {
  height: 100%;
  width: calc(100% - 200px);
  position: relative;

  .news-btns {
    position: absolute;
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 40px;
    right: -215px;

    .ant-btn {
      width: 120px;
      height: 40px;
      margin-bottom: 10px;
    }
  }
}

.spiderParse-item {
  display: flex;
  width: 100%;

  em {
    font-style: normal;
    flex: 0 0 90px;
    text-align: right;
  }

  span,
  .file-list {
    max-height: 200px;
    overflow: auto;
    padding-left: 5px;
    flex: 1;

    .list-item {
      margin-bottom: 10px;
    }
  }
}
.center {
  text-align: center;
}
.test-title {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  margin: 20px 0;
}
.author {
  color: #999;
}
.test-content {
  color: #666;
  margin-bottom: 0;
  line-height: 30px;
  font-size: 12px;
}
.test-key {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}
.file-url {
  color: #4683ff;
}
</style>
